module.exports = __webpack_public_path__ + "img/setTagInfo.dcacb511.png";